export default "__VITE_ASSET__Cu6CiTK3__"